enum Route {
  APPOINTMENT_GUIDES = '/appointment-guides',
  CUSTOMERS = '/customers',
  GLOBAL_CUSTOMERS = '/customer-search',
  CUSTOMER_PROFILE = '/customers/:customerId',
  CUSTOMER_PROFILE_DEPRECATED = '/profile/:customerId',
  FORMS = '/forms',
  FORMS_POST_APPOINTMENT_OUTCOME_FORM_CUSTOMER = '/forms/post-appointment-form/:customerId',
  HOME = '/',
  NOTIFICATIONS = '/notifications',
  REDIRECT = '/r',
  REDIRECT_ANONYMOUS = '/a',
  SETTINGS = '/settings',
  SETTINGS_SCHEDULING = '/settings/scheduling',
  INVENTORY_MANAGEMENT_SYSTEM = '/inventory-management-system',
}

export { Route }
